import { Volume } from '~/shared/types/api';
import { convertToGIB, formatBytes } from '~/shared/utils/formatNumber';

import { getDatafyUtilization, getProvisionedUtilization } from './helpers';

export const tableColumns: {
  key: keyof Volume;
  title: string;
  getValue?: (volume: Volume) => string;
}[] = [
  { key: 'volumeName', title: 'Name' },
  { key: 'volumeId', title: 'Volume ID' },
  { key: 'monitoring', title: 'Datafy Status' },
  { key: 'diskSize', title: 'Size', getValue: ({ diskSize }) => formatBytes(diskSize || 0) },
  {
    key: 'diskUsed',
    title: 'Utilization',
    getValue: (vol) => getProvisionedUtilization(vol),
  },
  {
    key: 'datafyDiskSize',
    title: 'Datafy Size',
    getValue: ({ datafyDiskSize }) => convertToGIB(datafyDiskSize),
  },
  {
    key: 'datafyDiskUsed',
    title: 'Datafy Utilization',
    getValue: (vol) => getDatafyUtilization(vol),
  },
  { key: 'diskType', title: 'Type' },
  { key: 'iops', title: 'IOPS' },
  { key: 'throughput', title: 'Throughput' },
  { key: 'awsState', title: 'AWS State' },
  { key: 'awsStatus', title: 'AWS Status' },
  { key: 'instanceId', title: 'Instance ID' },
  { key: 'availabilityZone', title: 'Availability Zone' },
  { key: 'region', title: 'Region' },
  { key: 'clusterName', title: 'Cluster' },
  { key: 'nodeGroupName', title: 'Node Group' },
  { key: 'osImage', title: 'OS Image' },
  {
    key: 'isBootDisk',
    title: 'Boot Volume',
    getValue: ({ isBootDisk }) => (isBootDisk ? 'Y' : 'N'),
  },
];
